import React from 'react'
import styles from './statistic-modal.module.scss'
import { billingStatus } from '../../helpers/helpers'

export default function SendStatisticStepTwo({ onExploreServices, onSkip }) {
  const handleExploreServices = () => {
    onExploreServices()
  }
  return (
    <div className={styles['statisticStepTwo']}>
      <b>
        <span role="img" aria-label="Magnifying glass emoji">
          🔎
        </span>{' '}
        Let us help you find the crew faster
      </b>
      <p>We understand that finding the right crew isn’t always easy.</p>
      <p>Many companies successfully fill their vacancies faster with:</p>
      <ul>
        <li>
          <span role="img" aria-label="Done emoji">
            ✔️
          </span>{' '}
          Premium vacancy placement
        </li>
        <li>
          <span role="img" aria-label="Done emoji">
            ✔️
          </span>{' '}
          Promotion among seafarers
        </li>
        <li>
          <span role="img" aria-label="Done emoji">
            ✔️
          </span>{' '}
          Personal recruitment by our managers
        </li>
      </ul>

      <p>We’re here to help you get the best results!</p>
      <div className={`${styles['statisticStep__buttons']} ${styles['statisticStep__buttons_column']}`}>
        {billingStatus() && (
          <button onClick={handleExploreServices} className={styles['statisticStep__button']}>
            Explore paid options
          </button>
        )}

        <button onClick={onSkip} className={styles['statisticStep__button']}>
          Skip
        </button>
      </div>
    </div>
  )
}
